export const TEST_IDS = Object.freeze({
	CARD_MERCHANT_TABLE: 'card-merchant-table',
	MERCHANT_CARD_TABLE: 'merchant-card-table',
	MERCHANT_NAME: 'merchant-name',
});
